import QuestionController from "../question_controller"

export default class extends QuestionController {
  static targets = ['selectMultiple', 'checkbox', 'selectOther', 'otherOptionWrapper', 'otherOptionText']

  handleOtherOptionChecked(event) {
    if (event.target.checked == undefined) {return}
    if (event.target.checked) {
      this.otherOptionWrapperTarget.classList.remove('disabled')
      this.otherOptionTextTarget.disabled = false
      this.keepOrClearCheckedAnswers(event.target)
    } else {
      this.otherOptionWrapperTarget.classList.add('disabled')
      this.otherOptionTextTarget.disabled = true
      this.otherOptionTextTarget.value = ""
    }
  }

  handleNonOtherOptionChecked(event) {
    this.keepOrClearCheckedAnswers(event.target)
    this.selectOtherTarget.checked = false
    this.otherOptionWrapperTarget.classList.add('disabled')
    this.otherOptionTextTarget.disabled = true
    this.otherOptionTextTarget.value = ""
  }

  keepOrClearCheckedAnswers(target) {
    if(this.canSelectMultiple()) {return}
    this.checkedFields().filter(field => field != target).forEach(element => element.checked = false);
  }

  selectedOtherChecked() {
    return this.hasSelectOtherTarget ? this.selectOtherTarget.checked : false;
  }

  canSelectMultiple() {
    return this.selectMultipleTarget.dataset.allowMultiple == "true"
  }

  checkedFields() {
    return this.checkboxTargets.filter(checkbox => checkbox.checked)
  }
  validateForm() {
    let valid = false

    if (this.selectedOtherChecked()) {
      valid = this.validateOther()
    } else {
      valid = this.validateSelectedOptions()
    }

    return valid
  }

  validateOther() {
    if (this.otherOptionTextTarget.value === "") {
      this.displayFlash("danger", "Text cannot be blank.")
      return false
    }

    return true
  }

  minOptionText(selectionCount) {
    return selectionCount > 1 ? "options need" : "option needs"
  }

  maxOptionText(selectionCount) {
    return selectionCount > 1 ? "options" : "option"
  }

  validateSelectedOptions() {
    this.toggleFlash(false)
    if (this.checkedFields().length == 0 && this.isRequired()) {
      this.displayFlash("danger", "You must select an option.")
      return false
    }

    if (this.limitSelection() && this.checkedFields().length < this.minSelection()) {
      this.displayFlash("danger", `At least ${this.minSelection()} ${this.minOptionText(this.minSelection())} to be selected.`)
      return false
    }

    if (this.limitSelection() && this.checkedFields().length > this.maxSelection()) {
      this.displayFlash("danger", `No more than ${this.maxSelection()} ${this.maxOptionText(this.maxSelection())} can be selected.`)
      return false
    }

    if (!this.canSelectMultiple() && this.checkedFields().length > 1) {
      this.displayFlash("danger", "You cannot select more than one option.")
      return false
    }

    return true
  }
}
